var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable max-lines */
import { comparer } from 'mobx';
import { merge } from 'bernie-core';
import { PaginationAttribute, ResourceHintLink } from 'bernie-http';
import { formatText, Localization } from 'bernie-l10n';
import loadable from '@loadable/component';
import { CONTROLLER_EVENTS } from 'controllers/events/controller-events';
import { PackageType } from 'models/multi-item/multi-item-types';
import { getHotelSearchPageData } from 'src/common/utils/controller-utils/page-data-util';
import { isBexSplitView } from 'src/common/utils/is-bex-split-view';
import { isMobile } from 'src/common/utils/is-mobile';
import { includeDynamicMapInSearchQuery } from 'src/common/utils/property-listing-utils';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';
import { isVrbo } from 'stores/context-store-utils';
import { SearchCriteriaModel, singleUseQueryParams, untrackedQueryParams } from 'stores/models';
import { SearchCriteriaUtils } from 'stores/models/search-criteria-utils';
import { getPackageType, getSearchTimeout, shouldCallMultiItemSessionMutation } from 'stores/multi-item-store-util';
import { SearchResultsStore } from 'stores/search-results-store';
import { evaluateAndLogExperiment, hasStoresChanged } from 'stores/utils';
import { getTrackingInfoForLogging } from 'utils/logging-utils';
import { meta } from 'utils/meta';
import { convertHashParams, shouldHashOverrideDefaultValues, shouldSearchHashParams } from './converters/legacy-hash-params';
import { processClientSideDefaultRequestFields } from './shared-controller-modules/utils';
import { DEFAULT_HOTEL_SEARCH_PAGE_ID, DEFAULT_HOTEL_SEARCH_PAGE_NAME } from 'constants/pages';
const {
  withoutKeys,
  withKeys
} = merge;
const CHINA_POS_SITE_ID = 100001;
export class SearchController {
  constructor() {
    this.bundles = ['search'];
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "search";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "search" */'views/lodging/search.tsx'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("views/lodging/search.tsx");
        }
        return eval('require.resolve')("views/lodging/search.tsx");
      }
    });
    this.pageId = DEFAULT_HOTEL_SEARCH_PAGE_ID;
    this.path = ['/', '/:locale?/search', '/:locale?/Hotel-Search', '/:locale?/search.do'];
    this.exact = true;
    this.routeName = 'search';
    this.routeData = {
      rfrrNamespace: 'HOT.SR',
      pageName: DEFAULT_HOTEL_SEARCH_PAGE_NAME
    };
  }
  // eslint-disable-next-line complexity
  fetch(options) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a, _b, _c;
      if (!options || !options.stores) {
        return Promise.reject('SearchController.fetch receieved an invalid StoreContainer');
      }
      const {
        isServer,
        query,
        stores,
        logger
      } = options;
      const fetchStartTime = Date.now();
      const context = stores.get('context');
      const page = stores.get('page');
      const analyticsStore = stores.get('analytics');
      const searchCriteria = stores.get('searchCriteria');
      const searchResults = stores.get('searchResults');
      const multiItem = stores.get('multiItem');
      const experiments = stores.get('experiment');
      const pageLayoutStore = stores.get('pageLayout');
      const analyticsSearch = stores.get('analyticsSearch');
      // sanitize incoming params
      const singleUseCriteria = withKeys(singleUseQueryParams).merge({}, options.query);
      const untrackedKeys = [...untrackedQueryParams, ...Object.keys(singleUseCriteria), 'prevQuery', 'l10n'];
      const prevQuery = withoutKeys(untrackedKeys).merge({}, query.prevQuery);
      const nextQuery = withoutKeys(untrackedKeys).merge({}, query);
      const packageType = getPackageType(query);
      this.initializeMultiItem(multiItem, query, nextQuery, context);
      searchResults.pageData = page;
      const isMapSearch = options.query.pwaOverlay === 'map';
      if (isMapSearch) {
        searchResults.initialLoadSearchPagination = undefined;
        searchResults.hotelsMaxDisplay = SearchResultsStore.HOTEL_TOTAL_RENDER_COUNT;
      } else {
        const fetchCount = searchResults.getInitialListingFetchCount(context, experiments);
        searchResults.initialLoadSearchPagination = fetchCount > 0 ? {
          size: fetchCount,
          startingIndex: 0
        } : {};
      }
      if (searchResults.foregoClientFetch) {
        searchResults.foregoClientFetch = false;
        const criteria = (_a = searchResults.searchCriteria) === null || _a === void 0 ? void 0 : _a.toJSON();
        const sqaParsedOut = SearchQueryAdapter.parseOut(criteria);
        return {
          query: sqaParsedOut,
          replace: true
        };
      }
      // if client side detects hash params, handle them
      if (!isServer && shouldSearchHashParams(nextQuery)) {
        const hashParams = convertHashParams();
        if (shouldHashOverrideDefaultValues(hashParams)) {
          searchResults.defaultRequestFields = {};
        }
        if (hashParams) {
          return {
            query: hashParams,
            replace: true
          };
        }
      }
      // server rendered with defaulted params, we need to adjust URLs first
      let newQuery = processClientSideDefaultRequestFields(isServer, searchResults, nextQuery);
      if (newQuery) {
        return newQuery;
      }
      const useBEXQuickFiltersTemplate = isMobile(context) && ((_c = (_b = experiments === null || experiments === void 0 ? void 0 : experiments.exposures) === null || _b === void 0 ? void 0 : _b.Quick_Filters_xLOB_Lodging_mWeb_Retest) === null || _c === void 0 ? void 0 : _c.bucket) === 1;
      const isBEXGSplitViewExperimentEnabled = isBexSplitView(context, experiments);
      pageLayoutStore.setSRPTemplate(context, multiItem.isPackageShoppingPath(), useBEXQuickFiltersTemplate, isBEXGSplitViewExperimentEnabled);
      const forceFetch = searchResults.shouldFetch;
      const isSameQuery = comparer.structural(nextQuery, prevQuery);
      // check if queries are different to previous state
      if (forceFetch || !isSameQuery) {
        // queries are meaningfully diff, setup base stores again
        searchCriteria.setValues(Object.assign(Object.assign(Object.assign({}, SearchCriteriaModel.getDefaults()), SearchCriteriaUtils.getFilterDefaults()), nextQuery));
        const modelData = SearchQueryAdapter.parseIn(searchCriteria.toJSON());
        const incomingSearchCriteria = new SearchCriteriaModel(modelData, new Localization(context.locale));
        const isCriteriaChanged = searchResults.searchCriteria && hasStoresChanged(searchResults.searchCriteria, incomingSearchCriteria);
        // fetches are only carried out if criteria is also changed
        if (forceFetch || !searchResults.searchCriteria || isCriteriaChanged) {
          if (isServer === true && query && multiItem.getPackageType() === PackageType.FH) {
            const bucket = evaluateAndLogExperiment('MIS_Lodging_SRP_Enable_Client_Side_Rendering_', context, experiments, page);
            query.skipServerFetch = bucket === 1 ? 'true' : query.skipServerFetch;
          }
          const skipSearchResultsFetch = isServer === true && query && query.skipServerFetch === 'true';
          const bucket = evaluateAndLogExperiment('ealo_shadow_audience_targeting_feature_gate', context, experiments, page);
          if (bucket === 1) {
            logger.logEvent(CONTROLLER_EVENTS.SHADOW_FLAVOR_TNL_TESTING, `Testing audience targeting on shadow flavors`);
          }
          if (isCriteriaChanged) {
            analyticsSearch.newSearchId();
          }
          yield this.doNetworking(page, analyticsStore, context, searchResults, incomingSearchCriteria, skipSearchResultsFetch, singleUseCriteria, searchCriteria, multiItem, packageType, analyticsSearch, experiments, pageLayoutStore).then(() => {
            if (logger) {
              logger.logEvent(CONTROLLER_EVENTS.SEARCH_CONTROLLER_FETCH, `fetchTime=${(Date.now() - fetchStartTime).toString()} ms`, `, isServer=${isServer}, ${getTrackingInfoForLogging(context)}`);
            }
          }).catch(error => {
            if (logger) {
              logger.logEvent(CONTROLLER_EVENTS.SEARCH_CONTROLLER_FETCH_FAILURE, error);
            }
          });
        }
      }
      // cleanup defaultRequestFields so they don't hang around for subsequent calls on clientside
      newQuery = processClientSideDefaultRequestFields(isServer, searchResults, nextQuery);
      if (newQuery) {
        return newQuery;
      }
      const isVRTitle = isVrbo(context);
      const destinationTitle = searchCriteria.destination ? searchCriteria.destination : searchCriteria.pageTitle;
      // `formatText` is deprecated. We should have the api create the localized page title and send it to the client.
      let pageTitle = '';
      if (destinationTitle && !isVRTitle) {
        pageTitle = formatText('hotels.searchResults.successfulSearch.pageTitle', destinationTitle);
      } else if (destinationTitle && isVRTitle) {
        pageTitle = formatText('hotels.searchResults.successfulSearch.VRPageTitle', destinationTitle);
      } else {
        pageTitle = formatText('hotels.searchResults.invalidSearch.pageTitle');
      }
      page.title = pageTitle;
      // `document` is undefined on the server only set `document.title` on the client.
      if (!isServer) {
        document.title = pageTitle;
      }
    });
  }
  initializeMultiItem(multiItem, query, nextQuery, context) {
    var _a;
    if (!((_a = multiItem.multiItemContext) === null || _a === void 0 ? void 0 : _a.id)) {
      multiItem.buildContext(query);
      multiItem.referrer = query.rfrr;
    }
    if (query.multiProp === 'true' && !query.businessModelFilter && nextQuery) {
      const defaultBusinessModel = multiItem.getDefaultBusinessModel();
      if (multiItem.cartInfo && multiItem.cartInfo.identifier === 'mixAndMatch') {
        multiItem.removeMixAndMatchCart();
        multiItem.getOrCreateCart(context, defaultBusinessModel);
      }
      nextQuery.businessModelFilter = defaultBusinessModel;
    }
  }
  doNetworking(page, analyticsStore, context, searchResults, incomingSearchCriteria, skipServerFetch, singleUseCriteria, searchCriteria, multiItem, packageType, analyticsSearch, experiments, pageLayoutStore) {
    return __awaiter(this, void 0, void 0, function* () {
      var _a;
      const pageFetch = page.fetch(meta['hotel-search'], context.site, context.locale);
      const isMultiItem = multiItem === null || multiItem === void 0 ? void 0 : multiItem.isPackageShoppingPath();
      let shouldCallCreateMISession = false;
      if (isMultiItem && searchResults.searchCriteria) {
        const isClientSide = !multiItem.isServerSide();
        shouldCallCreateMISession = shouldCallMultiItemSessionMutation(searchResults.searchCriteria, incomingSearchCriteria, multiItem.getPackageType());
        if (isClientSide && shouldCallCreateMISession) {
          if (((_a = experiments.exposures.TSDP_SRP_ServerDrivenSessionCreation) === null || _a === void 0 ? void 0 : _a.bucket) === 0) {
            yield searchResults.createSessionBeforeMultiItemFetch(multiItem, context, incomingSearchCriteria);
          } else {
            searchResults.isLoading = true;
            searchResults.propertySearchListings = [];
          }
          // Setting the regionId to null so that correct regionId is retrieved in spinner for multicity searches.
          if (searchResults.searchCriteria.regionId !== incomingSearchCriteria.regionId) {
            incomingSearchCriteria.regionId = undefined;
          }
        }
      }
      // Add an exception to allow for the filters to be updated if overfiltered
      // Add another expection to allow searching when the previous search was invalid
      const resultsHaveNoErrors = !searchResults.isError;
      const resultsOverFiltered = searchResults.overFiltered;
      const previousSearchWasInvalid = this.previousSearchWasInvalid(searchResults);
      if (resultsHaveNoErrors || resultsOverFiltered || previousSearchWasInvalid) {
        searchResults.updateSearchCriteria(incomingSearchCriteria);
        const searchResultsFetch = skipServerFetch ? Promise.resolve() : searchResults.fetch(getSearchTimeout(packageType), singleUseCriteria, {
          analytics: analyticsStore,
          analyticsSearch,
          context,
          experiment: experiments,
          multiItem,
          pageLayout: pageLayoutStore,
          searchCriteria: incomingSearchCriteria
        }, includeDynamicMapInSearchQuery(context, pageLayoutStore, experiments), shouldCallCreateMISession);
        yield Promise.all([pageFetch, searchResultsFetch]);
        if (isMultiItem) {
          searchResults.updateIsLoading(false);
        }
        this.updateSearchCriteriaFromSearchResults(searchResults, searchCriteria);
      }
    });
  }
  fetchPageData(options) {
    var _a, _b;
    const isSplitView = isVrbo(options.context);
    const additionalMeta = isSplitView ? this.addSplitViewResourceHints() : this.addResourceHints(options.context);
    const seo = {
      seo: Object.assign(Object.assign({}, ((_b = (_a = options.context) === null || _a === void 0 ? void 0 : _a.site) === null || _b === void 0 ? void 0 : _b.id) !== CHINA_POS_SITE_ID && {
        additionalMeta
      }), {
        // Temporary fix for issue: https://jira.expedia.biz/browse/BHS-17025
        robots: 'noindex,nofollow'
      })
    };
    const pageData = getHotelSearchPageData(options.query);
    return Promise.resolve(Object.assign(Object.assign({}, seo), pageData));
  }
  addResourceHints(context) {
    var _a;
    return [new PaginationAttribute(((_a = context === null || context === void 0 ? void 0 : context.deviceInformation) === null || _a === void 0 ? void 0 : _a.mobile) ? 'dns-prefetch' : 'preconnect', 'https://maps.googleapis.com/')];
  }
  addSplitViewResourceHints() {
    /**
     * Pairing 'preconnect' and 'dns-prefetch' based on recommendation from MDN
     * https://developer.mozilla.org/en-US/docs/Web/Performance/dns-prefetch#best_practices
     *
     * Map script should be fetched with high priority; otherwise the fetch would happen
     * only after map config arrives from backend
     */
    return [new ResourceHintLink('preconnect', 'https://maps.googleapis.com', 'script', undefined, 'anonymous', 'high'), new ResourceHintLink('dns-prefetch', '//maps.googleapis.com', undefined, undefined, 'anonymous', 'high')];
  }
  updateSearchCriteriaFromSearchResults(searchResults, searchCriteria) {
    // BFF may provide regionId when coming from SEM or alternate dates
    if (searchResults.searchCriteria) {
      searchCriteria.startDate = searchResults.searchCriteria.startDate;
      searchCriteria.endDate = searchResults.searchCriteria.endDate;
      searchCriteria.regionId = searchResults.searchCriteria.regionId;
      searchCriteria.typeaheadRegionType = searchResults.searchCriteria.typeaheadRegionType;
      searchCriteria.flexibility = searchResults.searchCriteria.flexibility;
      searchCriteria.searchRange = searchResults.searchCriteria.searchRange;
      searchCriteria.flexibleSearchRequirement = searchResults.searchCriteria.flexibleSearchRequirement;
    }
  }
  previousSearchWasInvalid(searchResults) {
    var _a;
    // Will return true if the previous search contained an invalid location
    return searchResults.isError && ((_a = searchResults.searchCriteria) === null || _a === void 0 ? void 0 : _a.regionId) === '';
  }
}